/**
 * @internal
 */
export class AttrJsonError {
  type: string;
}
